/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ToolCallOutcome = zod.enum(['ok', 'validation_error', 'error']);

export type ToolCallOutcome = zod.input<typeof ToolCallOutcome>;
export type ToolCallOutcomeOutput = zod.output<typeof ToolCallOutcome>;
